import React from "react";
import EnquiryForm from "@/components/EnquiryForm";
import { Check } from "lucide-react";
import { fmtINR } from "@/lib/api";

const PLANS = [
  {
    name: "Personal", price: 999, period: "yearly", tag: "Best for personal cars & bikes",
    features: ["Real-time tracking", "Anti-theft alerts", "Mobile app access", "90-day trip history", "Standard email support"],
  },
  {
    name: "Business", price: 1999, period: "yearly", tag: "Best for SMEs (up to 20 vehicles)", popular: true,
    features: ["Everything in Personal", "Fleet dashboard", "Geofencing (10 zones)", "Driver behaviour reports", "Priority WhatsApp support"],
  },
  {
    name: "Enterprise", price: null, period: "custom", tag: "Best for large fleets & logistics",
    features: ["Custom device volume pricing", "API & webhook access", "Fuel & temperature sensors", "Dedicated account manager", "24×7 phone support & SLA"],
  },
];

export default function Pricing() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="pricing-page">
      <div className="max-w-3xl">
        <div className="eyebrow">Subscription plans</div>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0A192F] mt-3">Transparent pricing for every vehicle</h1>
        <p className="mt-4 text-slate-600">All plans include the KSPB tracking platform, mobile app and standard alerts. Device and installation are billed separately.</p>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
        {PLANS.map((p) => (
          <div key={p.name} className={`p-6 rounded-2xl border ${p.popular ? "border-[#FF6D00] bg-white shadow-xl" : "border-slate-200 bg-white"} tile-hover`} data-testid={`plan-${p.name.toLowerCase()}`}>
            {p.popular && <div className="inline-block bg-[#FF6D00] text-white text-[10px] font-semibold uppercase tracking-widest px-3 py-1 rounded-full mb-4">Most popular</div>}
            <h3 className="font-heading text-xl font-bold text-[#0A192F]">{p.name}</h3>
            <p className="text-sm text-slate-500 mt-1">{p.tag}</p>
            <div className="mt-4 flex items-end gap-2">
              {p.price ? (
                <>
                  <div className="font-heading text-4xl font-bold text-[#0A192F]">{fmtINR(p.price)}</div>
                  <div className="pb-1 text-sm text-slate-500">/ {p.period}</div>
                </>
              ) : (
                <div className="font-heading text-3xl font-bold text-[#FF6D00]">Custom</div>
              )}
            </div>
            <ul className="mt-6 space-y-2">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2 text-sm text-slate-700">
                  <Check className="w-4 h-4 text-[#00E676] mt-0.5" /> {f}
                </li>
              ))}
            </ul>
            <a href="#pricing-enquiry" className={`mt-6 w-full inline-flex items-center justify-center h-11 rounded-full font-semibold ${p.popular ? "bg-[#FF6D00] text-white" : "bg-[#0A192F] text-white"}`}>
              {p.price ? "Get Started" : "Request a Quote"}
            </a>
          </div>
        ))}
      </div>

      <div className="mt-16" id="pricing-enquiry">
        <EnquiryForm title="Not sure which plan to pick?" subtitle="Tell us your fleet size and we'll recommend the right plan." enquiry_type="quote" testIdPrefix="pricing-enquiry" />
      </div>
    </div>
  );
}
